import React from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { setExamFinished, setVideoWatched, resetTest } from '../app/store'

const ResultsRecapFail = () => {

    const { i18n,t } = useTranslation();
    const user = useSelector((state)=> state.user)
    const questions = useSelector((state)=> state.questions)
    const dispatch = useDispatch()

    const handleRewatch = () => {
        dispatch(resetTest())
        dispatch(setExamFinished(false))
        dispatch(setVideoWatched(false))
    }

    const handleTryAgain = () => {
        dispatch(resetTest())
        dispatch(setExamFinished(false))
        
    }


  return (
    <div className='container'>
        <div className='row'>
        <div className='col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 border rounded p-4 login-form'>
            <h3 className='text-center'>{t('peccato')}!</h3>
            <h4 className='text-center'>{t('esame_non_superato')}</h4>
            <div className='row'>
                <h5 className='text-center'>{t('esito')}:</h5>
                <div className='col-12 text-center mt-3'>{t('risposte_corrette')}: {user.score} / {questions.tot_questions}</div>
                <div className='col-12 text-center mb-3'>{t('punteggio_minimo')}: {questions.min_score_to_pass}</div>
            </div>
            <div className='col-12 text-center mt-3'>
                <button type='button' className={'basf-btn inverted m-0 btn_length_' +i18n.language} onClick={()=>(handleRewatch())}>{t('riguarda_video')}</button>
                <button type='button' className={'basf-btn mx-2 mt-2 btn_length_' +i18n.language} onClick={()=>{handleTryAgain()}}>{t('riprova_quiz')}</button>
            </div>
        </div>
        
        </div>
    </div>
  )
}

export default ResultsRecapFail